import React, { useState, useEffect } from 'react';
import { Container } from 'react-bootstrap';
import TopNav from '../TopNav/TopNav';
import LeftNav from '../LeftNav/LeftNav';
import { useAuth } from '../../AuthContext';
import { useParams } from 'react-router-dom';

const MainLayout = ({ children }) => {
  const [navExpanded, setNavExpanded] = useState(true);

  const { tenantDomain } = useParams();
  const { updateTenantDomain } = useAuth();
  useEffect(() => {
      updateTenantDomain(tenantDomain);
  }, [tenantDomain]);

  const toggleNav = () => {
    setNavExpanded(!navExpanded);
  };

  return (
    <div className="min-vh-100" style={{ backgroundColor: '#f8f9fa' }}>
      <TopNav />
      <LeftNav expanded={navExpanded} onToggle={toggleNav} />
      
      <div
        style={{
          marginLeft: navExpanded ? '250px' : '60px',
          marginTop: '56px',
          transition: 'margin-left 0.3s ease',
          padding: '20px'
        }}
      >
        <Container fluid>
          {children}
        </Container>
      </div>
    </div>
  );
};

export default MainLayout;